import { useCallback, useEffect, useRef, useState } from 'react'
import '../address/loading.scss'
import './myOrder.scss'
import util from '../../utils/util'
import userUtils from '../../manager/userUtils'
import View from '../../components/Base/View'
import { Tabs } from 'antd'
import ScrollView from '../../components/Base/ScrollView'
import Block from '../../components/Base/Block'
import Loading from '../../components/Loading'
import EmptyTip from '../../components/EmptyTip'
import httpUtil from '../../utils/httpUtil'
import EventBus from '../../utils/EventBus'
import OrderListItem from '../../components/OrderListItem'
import RefundRequestDialog, { RefundRequestDialogRef } from '../../components/RefundRequestDialog'
import ShipmentListModal, { ShipmentListModalRef } from '../../components/ShipmentListModal'

const MyOrder = () => {
    const columns = [
        {
            name: '全部',
            status: 0,
        },
        {
            name: '待付款',
            status: 10,
        },
        {
            name: '待发货',
            status: 20,
        },
        {
            name: '待收货',
            status: 30,
        },
        {
            name: '已完成',
            status: 40,
        },
    ]
    const [dataList, setDataList] = useState<(any[])[]>([[], [], [], [], []]);
    const [needRefresh, setNeedRefresh1] = useState<boolean[]>([false, false, false, false, false]);
    const [currentColumn, setCurrentColumn] = useState<number>(0);
    const [isLoading, setLoading1] = useState<boolean[]>([false, false, false, false, false]);
    const [noMore, setNoMore1] = useState<boolean[]>([false, false, false, false, false]);
    const [loadFailed, setLoadFailed1] = useState<boolean[]>([false, false, false, false, false]);

    const isSwitchColumn = useRef<boolean>(false)
    const pageNum = useRef<number[]>([1, 1, 1, 1, 1]);

    const refundDialogRef = useRef<RefundRequestDialogRef>()
    const shipmentDialogRef = useRef<ShipmentListModalRef>();

    const loadList = useCallback((isRefresh: boolean, index: number) => {
        const setLoading = (index: number, loading: boolean) => {
            setLoading1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setNoMore = (index: number, loading: boolean) => {
            setNoMore1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setLoadFail = (index: number, loading: boolean) => {
            setLoadFailed1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setNeedRefresh = (index: number, loading: boolean) => {
            setNeedRefresh1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        if (!isRefresh && (isLoading[index] || noMore[index])) {
            return
        }
        if (isRefresh) {
            pageNum.current[index] = 1
            setNoMore(index, false)
            setLoadFail(index, false)
            setNeedRefresh(index, false)
        }
        setLoading(index, true)
        httpUtil.link(
            {
                apiName: 'customerorders',
                OrderStatus: columns[index].status,
                Page: pageNum.current[index],
                PageSize: 10,
            },
            'GET',
            {},
            true,
            function (success: boolean, res: any, tips: string) {
                if (success) {
                    var result = res.data.Content
                    if (result.Orders.length > 0) {
                        pageNum.current[index] = pageNum.current[index] + 1
                    } else {
                        setNoMore(index, true)
                    }
                    var listArray = dataList

                    // 對時間進行處理
                    result.Orders.forEach(function (item: any) {
                        if (item.AutoCloseUnpayedMinutes) {
                            item.leftTimeStr = util.getLeftTimeStr(
                                item.CreatedOn,
                                item.AutoCloseUnpayedMinutes
                            )
                        }
                    })
                    listArray[index] = isRefresh
                        ? result.Orders
                        : listArray[index].concat(result.Orders)
                    setDataList(listArray)
                } else {
                    setLoadFail(index, true)
                }
                setLoading(index, false)
            }
        )
    }, [noMore, loadFailed, isLoading])

    useEffect(() => {
        const urlInfo = util.parasUrl(window.location.href);
        let status = 0;
        switch ((urlInfo.params as any).state || 'all') {
            case 'waitPay':
                status = 10
                break
            case 'waitShip':
                status = 20
                break
            case 'waitConfirm':
                status = 30
                break
            case 'confirmed':
                status = 40
                break
            case 'all':
            default:
                status = 0
                break
        }
        const index = columns.findIndex(i => {
            return i.status == status;
        })
        if (index >= 0) {
            setCurrentColumn(index);
        }

    }, [])


    useEffect(() => {
        document.title = "我的订单";
        userUtils.doTaskInLoginState(function (state) {
            if (state.success) {
                loadList(true, currentColumn)
            }
        })
        const onOrderStateChangeListener = () => {
            const needRefresh: boolean[] = [];
            columns.forEach(function (item, index) {
                if (index !== currentColumn) {
                    needRefresh.push(true)
                } else {
                    needRefresh.push(false)
                }
            })
            setNeedRefresh1(needRefresh)
            // 加载当前列表数据
            loadList(true, currentColumn)
        }
        EventBus.register(EventBus.names.ORDER_STATE_CHANGE, onOrderStateChangeListener);
        return () => {
            EventBus.unregister(EventBus.names.ORDER_STATE_CHANGE, onOrderStateChangeListener);
        }
    }, [currentColumn])

    return <View
        className="my-order-page"
    >
        <View className="container">
            <View className="main-container">
                <Tabs
                    centered
                    style={{
                        height: "100%",
                        overflow: "hidden"
                    }}
                    className="lists-container"
                    activeKey={`${currentColumn}`}
                    onChange={(key) => {
                        setCurrentColumn(parseInt(key));
                    }}

                    items={columns.map((i, index) => {
                        return {
                            label: i.name,
                            key: `${index}`,
                            children: <>
                                <ScrollView
                                    className="list-container"
                                    scrollY={true}
                                    onReachBottom={()=>{
                                        loadList(false, currentColumn)
                                    }}
                                    enableBackToTop={true}
                                    scrollWithAnimation={true}
                                >
                                    {dataList[currentColumn].map((item, listItemIndex) => {
                                        return (
                                            <Block>
                                                <OrderListItem
                                                    orderInfo={item}
                                                    onOrderCanceled={() => {
                                                        util.navigateTo(
                                                            '/order/order?isrmmp=1&hidemenu=1&id=' + item.Id + '&checkstate=1'
                                                        )
                                                    }}
                                                    onOrderConfirmed={() => {
                                                        util.navigateTo(
                                                            '/order/order?isrmmp=1&hidemenu=1&id=' + item.Id + '&checkstate=1'
                                                        )
                                                    }}
                                                    onOrderPayed={() => {
                                                        util.navigateTo(
                                                            '/order/order?isrmmp=1&hidemenu=1&id=' + item.Id + '&checkstate=1'
                                                        )
                                                    }}
                                                    onOpenShipmentDialog={(productInfo: any) => {
                                                        //TODO: 查看物流
                                                        shipmentDialogRef.current?.open(productInfo)
                                                    }}
                                                    onRefundOrder={() => {
                                                        refundDialogRef.current?.open(item);

                                                    }}
                                                ></OrderListItem>
                                            </Block>
                                        )
                                    })}
                                    {isLoading[currentColumn] ? (
                                        <Loading
                                            style={{
                                                width: 25,
                                                height: 25,
                                                marginTop: 25,
                                                marginBottom: 25,
                                                opacity: 0.5
                                            }}
                                        ></Loading>
                                    ) : (
                                        ((noMore[currentColumn] &&
                                            dataList[currentColumn].length > 0) ||
                                            loadFailed[currentColumn]) && (
                                            <Block>
                                                <View
                                                    className="loading-tip"
                                                  onClick={()=>{
                                                    if(loadFailed[currentColumn]){
                                                        loadList(dataList[currentColumn].length === 0, currentColumn)
                                                    }
                                                  }}
                                                >
                                                    {noMore[currentColumn]
                                                        ? '没有更多了'
                                                        : '加载失败，点我重试'}
                                                </View>
                                            </Block>
                                        )
                                    )}
                                </ScrollView>
                                {!isLoading[currentColumn] &&
                                    !loadFailed[currentColumn] &&
                                    dataList[currentColumn].length === 0 && (
                                        <EmptyTip
                                            data={{
                                                icon: require('../../images/empty_order.png'),
                                                tip: '暂无相关订单',
                                                btn: '',
                                            }}
                                            emptyBtnClick={() => {
                                                // this.emptyBtnClick
                                            }}
                                        ></EmptyTip>
                                    )}
                            </>
                        }
                    })}
                >
                </Tabs>
            </View>
        </View>
        <RefundRequestDialog ref={refundDialogRef}></RefundRequestDialog>
        <ShipmentListModal ref={shipmentDialogRef} />
    </View>
}

export default MyOrder;